export enum RetrieveFields {
  RETRIEVE_FORM = 'retrieveForm',
  FAMILY_NAME = 'familyName',
  CASE_NUMBER = 'caseNumber',
}

export interface RetrieveFormData {
  [RetrieveFields.RETRIEVE_FORM]: {
    [RetrieveFields.CASE_NUMBER]: string;
    [RetrieveFields.FAMILY_NAME]: string;
  };
}
